<div class="header">
  <div class="deloitte-logo"></div>
  <div class="project-name">A&A People Feed</div>

  @if (!hideutility) {
    <div class="project-tab"
      routerLink="/"
      routerLinkActive="active-tab"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="Homepage()">
      Utility
    </div>
  }

  <div class="project-tab"
    routerLink="/containermappings"
    routerLinkActive="active-tab"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="routeToContainerMapping()">
    Container Mappings
  </div>

  @if (showDqViolations) {
    <div class="project-tab"
      routerLink="/dq-gate"
      routerLinkActive="active-tab"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="routeToDqViolations()">
      DQ Violations
    </div>
  }

  @if (isUserAuthorized) {
    <opm-current-user></opm-current-user>
  }
  @if (isUserAuthorized) {
    <opm-help-menu></opm-help-menu>
  }

  <span class="bell-icon" routerLink="/" (click)="bellIconClicked()">
    @if (opmUpdatesAvailable) {
      <span class="bell-indicator"></span>
    }
  </span>
</div>
